<template>
  <div class="d-flex">
    <span
      v-for="index in completed"
      :key="`enem-weight-${index}`"
      :class="`level-bar bg-${type}`"
    />
    <span
      v-for="index in 10 - completed"
      :key="index"
      class="level-bar bg-gray-dark"
    />
  </div>
</template>
<script>
export default{
  props:{
    bars:{
      default: 10,
      required: false,
      type:Number
    },
    completed:{
      required:true,
      type: Number,
    },
    type:{
      default: 'nitro',
      type:String,
    }
  }
}
</script>
